import React, { useEffect, useState } from "react";
import SurveyListHeader from "../../../../component/layout/MainHeader";
import { Link, useNavigate } from "react-router-dom";
import { getTokenData } from '../../../../store/actions/authAction';

import AccountSettingSidebar from "../components/AccountSettingSidebar";
import SearchInput from "../../../../core/Inputs/SearchInput";
import Svg from "../../../../component/Svg";
import Card from "../../../../core/Card";
import style from "../../../style.module.css";
import team1 from "../../../../assets/images/team1.jpg";
import team2 from "../../../../assets/images/team2.jpg";
import team3 from "../../../../assets/images/team3.jpg";
import team4 from "../../../../assets/images/team4.jpg";
import SurveyListSidebar from "../../../../component/layout/MainSidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTeam,
  getTeamList,
  leaveTeam,
  deleteTeamMember
} from "../../../../store/actions/teamAction";
import NestedMenuToggle from "../NestedMenuToggle";

import DataTable from "react-data-table-component";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



export default function Teams() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteTeamData, setDeleteTeamData] = useState(null);
  const initialFilters = { search: '', status: '' }
  const [filters, setFilters] = useState(initialFilters);
  const [userId, setuserId] = useState('');
  // const [serverParams, setServerParams] = useState({
  //   startingLimit: 0,
  //   resultsPerPage: 8,
  //   search: "",
  //   sort_by: "team_name",
  //   sort_order: "asc",
  // });
  //Functionlaities
  const handleSearch = (value) => {
    setFilters({ ...filters, search: value })
  }
  useEffect(() => {
    dispatch(getTokenData(setuserId))
  }, [userId, dispatch])

 
  const [serverParams, setServerParams] = useState({
    startingLimit: 0,
    resultsPerPage: 8,
    search: "",
  });
  const [sortValue, setSortValue] = useState("Recently added");
  const sortingOptions = [
    { id: 1, value: "asc", label: "Sort A-Z" },
    { id: 2, value: "desc", label: "Sort Z-A" },
  ];

  const {
    teamDataLoading: loading,
    teamData: teamList,
    totalRecords,
  } = useSelector((state) => state.teamData);


  const getTeams = () => {
    dispatch(getTeamList(serverParams));
  };

  const [teamLeft, setTeamLeft] = useState(false);

  const [searchText, setSearchText] = useState("");

  const teamLeave = async (teamID) => {
    let payload = { team_id: teamID };
    dispatch(leaveTeam(payload))
      .then(() => {
        toast.success("Successfully left the team");
        setTeamLeft(true);
        deleteTeamMember(teamID);
        // dispatch(deleteTeam(payload));
        getTeams();

        // Set teamLeft to true after successfully leaving the team
      })
      .catch((error) => {
        toast.error("Error leaving the team");
      });
  };

  const dropTeam = async (teamId) => {
    let payload = {
      team_id: teamId,
    };

    await dispatch(deleteTeam(payload));
    closeDeleteModal();
    getTeams();
  };

  const openDeleteModal = (team) => {
    setDeleteTeamData(team);
    let deleteModal = document.getElementById("deleteModal");
    let modal = window.bootstrap.Modal.getOrCreateInstance(deleteModal);
    if (modal && !modal._isShown) {
      modal.show();
    }
  };

  const closeDeleteModal = () => {
    let deleteModal = document.getElementById("deleteModal");
    let modal = window.bootstrap.Modal.getOrCreateInstance(deleteModal);
    if (modal && modal._isShown) {
      modal.hide();
    }
    setDeleteTeamData(null);
  };
   //Effects
   useEffect(() => {
    dispatch(getTokenData(setuserId))
  }, [userId, dispatch])
  useEffect(() => {
    if (userId) {
      const payload = {
        user_id: userId,
        search: filters.search,
        status: filters.status
      }
      dispatch(getTeamList(payload));
    }
   // getTeams(payload);
  }, [filters,userId]);

  const columns = [
    {
      width: '300px',
      name: 'Team Name',
      selector: 'team_name',
      sortable: true,
    },
    {
      
      name: 'Members',
      // selector: 'count_user',
      cell: (row) => {
        return (
          
          <div className="text-center w-100">{row.count_user}</div>
        )
      },
      sortable: true,
    },
    {
      name: "Action",
      width: '100px',
      cell: (row) => (
        <>
          <div className="d-flex action-wrapper">
            {window.modulePermissions.M5.edit === 1 && (
              <a
                className="action-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Edit"
                onClick={() => {
                  navigate("/admin/settings/teams/edit", {
                    state: { teamId: row.team_id },
                  });
                }}
              >
                <Svg name="table-edit" />
              </a>
            )}
            {row.count_user !== 0 && (
              <a
                className="action-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Leave"
                onClick={() => {
                  teamLeave(row.team_id);
                }}
              >
                <Svg name="table-remove" />
              </a>
            )}
            {window.modulePermissions.M5.del === 1 && row.can_delete === 1 && (
              <a
                className="action-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Delete"
                onClick={() => {
                  openDeleteModal(row);
                }}
              >
                <Svg name="table-delete" />
              </a>
            )}
          </div>

          {/* <div className="dropdown dropup">
          <button
            className="btn"
            type="button"
            id={`actions-${row.team_id}`}
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <Svg name="action" />
          </button>
          <div className="dropdown-menu" aria-labelledby={`actions-${row.team_id}`}>
            {window.modulePermissions.M5.edit === 1 && (
              <a
                className="dropdown-item"
                onClick={() => {
                  navigate("/admin/settings/teams/edit", {
                    state: { teamId: row.team_id },
                  });
                }}
              >
                Edit
              </a>
            )}
            {row.count_user !== 0 && (
              <a
                className="dropdown-item"
                onClick={() => {
                  teamLeave(row.team_id);
                }}
              >
                Leave
              </a>
            )}
            {window.modulePermissions.M5.del === 1 && row.can_delete === 1 && (
              <a
                className="dropdown-item"
                onClick={() => {
                  openDeleteModal(row);
                }}
              >
                Delete
              </a>
            )}
          </div>
        </div> */}
        </>
      ),
    },
    // Add more columns as needed
  ];

  // const handleSearch = (searchText) => {
  //   setServerParams({
  //     ...serverParams,
  //     search: searchText,
  //   });
  // };
 

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/dashboard"
                        className="home-item"
                        title="Dashboard"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    {/* <li className="breadcrumb-item">
                        <Link to="/admin/settings/user-permissions">
                          User & Teams
                        </Link>
                      </li> */}
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      <strong>Teams</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Teams</h1>
                    </div>
                  </div>
                </div>
                <div className="role-wrapper flex-grow-1">
                  <div className="pagesRow varPg">
                    <div className="page-heading heading-section-new mb-3">
                      <p>Teams are groups of users working together on specific projects or tasks.</p>
                    </div>
                    {/* Empty State of User Role */}

                    <div className="table-wrapper-view">
                      <div className="search-filter d-md-flex align-items-center">
                        <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                          <SearchInput
                            className="custom-search-input"
                            type="def"
                            view="outlined"
                            color="primary"
                            placeholder="Search"
                            fill={true}
                            onSearch={handleSearch}
                            onSearchIconClick={handleSearch}
                            onClear={() => setFilters({ ...filters, search: '' })}
                            value={searchText}

                            // onChange={(e) => {

                            //   setServerParams({
                            //     ...serverParams,
                            //     search: searchText,
                            //   });
                            // }}

                            // onKeyDown={(e) => {
                            //   if (e.key === 'Enter') {
                            //     setServerParams({
                            //       ...serverParams,
                            //       search: e.target.value,            // Use searchText instead of e.target.value
                            //     });
                            //   }
                            // }}

                            // onClear={() => {
                            //   setServerParams({
                            //     ...serverParams,
                            //     search: "",
                            //   });
                            // }}

                          />
                        </div>
                        <div className="drop-wrap d-flex align-items-center pe-0 pe-md-3 mb-3 mb-md-0">
                          {/* <label>Sort By - </label> */}
                          <div className="dropdown table-dropdown ques-options">
                            {/* <button
                              className="btn dropdown-tgl"
                              type="button"
                              id="sort"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {sortValue}
                            </button> */}
                            <div className="dropdown-menu" aria-labelledby="sort">
                              {/* {sortingOptions.map((sort) => (
                                <a
                                  className="dropdown-item"
                                  key={sort.id}
                                  onClick={() => {
                                    setServerParams({
                                      ...serverParams,
                                      sort_order: sort.value,
                                    });
                                    setSortValue(sort.label);
                                  }}
                                >
                                  {sort.label}
                                </a>
                              ))} */}
                            </div>
                          </div>
                        </div>
                        {window.modulePermissions.M5.add == 1 && (
                          <div className="button-wrap">
                            <Link
                              to="/admin/settings/teams/create"
                              className="btn btn-primary add-btn"
                            >
                              <Svg name="plus" /> Create{" "}
                            </Link>
                          </div>
                        )}

                      </div>
                      <div className="teams-wrap">
                        {/* <div className="row gx-12px">
                          {teamList.length > 0 &&
                            teamList.map((team, teamIndex) => (
                              <div className="col-xxl-3 col-lg-4 col-sm-6" key={teamIndex}>
                                <div className="team-wrapper mb__12 text-center">
                                  <div className="dropdown">
                                    <button
                                      className="btn dropdown-tgl"
                                      type="button"
                                      id="options"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                        <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                        <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                        <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                      </svg>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options" >
                                      {window.modulePermissions.M5.edit == 1 && (
                                        <a
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            navigate("/admin/settings/teams/edit", {
                                              state: {
                                                teamId: team.team_id,
                                              },
                                            });
                                          }}
                                        >
                                          Edit
                                        </a>
                                      )}
                                      <div>
                                      {team.count_user !=0 && (                                       
                                          <a
                                            className="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                              teamLeave(team.team_id);
                                              console.log("Onclick team leave")
                                            }}
                                          >
                                            Leave
                                          </a>
                                      )}
                                      </div>
                                      {window.modulePermissions.M5.del == 1 && team.can_delete == 1 && (
                                        <a
                                          className="dropdown-item"
                                          // data-bs-toggle="modal"
                                          // data-bs-target="#deleteModal"
                                          onClick={() => {
                                            openDeleteModal(team);
                                          }}
                                        >
                                          Delete
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                  <div className="img-wrapper">
                                    <img src={team1} alt="" className="img-fluid" />
                                  </div>
                                  <div className="text-wrap">
                                    <h4 title={team.team_name}>{team.team_name}</h4>
                                    <p>{team.count_user} Members </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div> */}
                      </div>
                      <div className="table-responsive survey-table">
                        <div className="table-wrap custom-data-table no-width">

                          <DataTable
                            columns={columns} // Define your columns array
                            data={teamList} // Pass your team data to the datatable
                            pagination
                            paginationServer
                            paginationTotalRows={totalRecords} // Total number of records for pagination
                          // onChange={(tableState) => {
                          //   // Handle pagination and sorting changes
                          //   const { page, sortField, sortOrder, search } = tableState;
                          //   setServerParams({
                          //     ...serverParams,
                          //     startingLimit: page * serverParams.resultsPerPage,
                          //     sort_by: sortField || "team_name",
                          //     sort_order: sortOrder || "asc",
                          //     search: search || "", 
                          //   });
                          // }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  {deleteTeamData && (
                    <Card
                      view="raised"
                      className={"formstyle p-0" + " " + style.card}
                    >
                      <div className="delete-body-wrap delete-language">
                        <div className="heading">
                          <h3>Delete team</h3>
                        </div>
                        <div className="team-listing d-inline-flex align-items-center">
                          <div className="img-wrapper">
                            <img src={team1} alt="" className="img-fluid" />
                          </div>
                          <div className="text-wrap flex-grow-1 ps-3">
                            <h5>{deleteTeamData.team_name}</h5>
                            <p>{deleteTeamData.count_user} Members</p>
                          </div>
                        </div>
                        <div className="warning-message">
                          <div className="title d-flex align-items-center">
                            <svg
                              width={40}
                              height={42}
                              viewBox="0 0 40 42"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 2L37.3205 32H2.67949L20 2Z"
                                stroke="#F05454"
                                strokeWidth={3}
                                strokeLinejoin="round"
                              />
                              <path
                                d="M20 13.5385V22"
                                stroke="#F05454"
                                strokeWidth={3}
                              />
                              <circle
                                cx="19.9994"
                                cy="25.8461"
                                r={1}
                                fill="black"
                                stroke="#F05454"
                                strokeWidth="1.07692"
                              />
                            </svg>
                            <h4>Warning</h4>
                          </div>
                          <p>
                            By deleting this team you will be deleting all the
                            team members and related infomation
                          </p>
                        </div>

                        <div className="button-wrap d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-bordered color-cancel"
                            onClick={() => {
                              closeDeleteModal();
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-delete ms-3"
                            onClick={() => {
                              dropTeam(deleteTeamData.team_id);
                            }}
                          >
                            Confirm delete
                          </button>
                        </div>
                      </div>
                    </Card>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

